import APP from "./app/appObj";
//import Indices from "./components/indices";
import { Dropdown, Modal } from "bootstrap";

/**
 * Get Document Ready
 */
document.addEventListener("DOMContentLoaded", () => {
  APP.helpers.initComponents(document.body, APP);
  APP.helpers.onLoadEvents(document.body, APP);
  //Indices;
  // APP.helpers.initLazyLoading(APP);
  //Indices;
  Dropdown;
  Modal;
  document.body.classList.remove("preload");
});
